"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateDetails = exports.TemplateDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const package_1 = require("../package");
const TitanShapes_1 = require("../shapes/TitanShapes");
const utils_1 = require("../utils");
require("./TemplateDropdown.scss");
const TemplateDropdown_scss_json_1 = __importDefault(require("./TemplateDropdown.scss.json"));
const Topic_1 = require("../shapes/Topic");
const Location_1 = require("../shapes/Location");
exports.TemplateDropdown = (0, package_1.linkedComponent)(TitanShapes_1.AdSet, ({ source, isLightTheme, isChecked, onSelect, ...props }) => {
    const toggleDetails = () => {
        onSelect && onSelect(source);
    };
    const { uri, name } = source;
    // Split the string by '-'
    const parts = name.split('-').map(str => str.trim());
    const templateName = parts[0] || '';
    let targetPlacement = source.placement || '';
    let targetGender = source.targetsFemales && source.targetsMales && source.targetsUnknown ? "All Genders" : source.targetsFemales ? "Female" : source.targetsMales ? "Male" : source.targetsUnknown ? "Unknown" : "";
    let targetDeviceBrowser = source.deviceAndBrowser;
    //   if (parts.length === 3) {
    //     targetGender = parts[1];           
    //     targetDeviceBrowser = parts[2];   
    //   } else if (parts.length === 4) {
    //     targetPlacement = parts[1];       
    //     targetGender = parts[2];           
    //     targetDeviceBrowser = parts[3];    
    //   }
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${isLightTheme ? TemplateDropdown_scss_json_1.default.dropdown : TemplateDropdown_scss_json_1.default.dropdownDark} ${TemplateDropdown_scss_json_1.default.tableTemplates}`, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: isChecked, onChange: toggleDetails }) }), (0, jsx_runtime_1.jsx)("div", { className: TemplateDropdown_scss_json_1.default.toggleValue, children: templateName }), (0, jsx_runtime_1.jsx)("div", { className: TemplateDropdown_scss_json_1.default.toggleValue, children: targetPlacement || '' }), (0, jsx_runtime_1.jsx)("div", { className: TemplateDropdown_scss_json_1.default.toggleValue, children: targetGender }), (0, jsx_runtime_1.jsx)("div", { className: TemplateDropdown_scss_json_1.default.toggleValue, children: targetDeviceBrowser })] }, uri));
});
exports.TemplateDetails = (0, package_1.linkedComponent)(TitanShapes_1.AdSet.request((template) => {
    var _a, _b, _c;
    return ({
        campaign: template.campaign,
        campaignConversionObjective: (_a = template.campaign) === null || _a === void 0 ? void 0 : _a.conversionObjective,
        campaignDailyBudget: (_b = template.campaign) === null || _b === void 0 ? void 0 : _b.dailyBudget,
        campaignLifetimeBudget: (_c = template.campaign) === null || _c === void 0 ? void 0 : _c.lifetimeBudget,
        template,
        topics: template.topics,
        keywords: template.keywords,
        geolocations: template.geolocations,
        excludedGeolocations: template.excludedGeolocations,
    });
}), ({ linkedData, deletionCallback, isLightTheme, readonly, }) => {
    const { campaign, template, topics, keywords, excludedGeolocations, geolocations } = linkedData;
    const { uri, name } = template;
    const templateOptions = (0, utils_1.getInputsByPlatform)('quora');
    const byAdSetAndCampaign = (option) => option.column !== 'ad' &&
        !option.internal &&
        !option.hidden &&
        option.title !== 'Date Launched';
    return (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h2", { children: ["Details of: ", template.name] }), (0, jsx_runtime_1.jsx)("table", { className: TemplateDropdown_scss_json_1.default.table, children: (0, jsx_runtime_1.jsxs)("tbody", { children: [' ', templateOptions.filter(byAdSetAndCampaign).map((option) => {
                            let optionValue;
                            if (option.column === 'adset') {
                                optionValue = template.getValue(option.shapePath);
                            }
                            else {
                                optionValue = template.campaign.getValue(option.shapePath);
                            }
                            if (option.title === 'Targeting Description') {
                                switch (template.targetingType) {
                                    case 'Contextual Topics':
                                    case 'Behavioral Interests':
                                        optionValue = topics.map((topic) => {
                                            return (0, jsx_runtime_1.jsx)(TopicView, { of: topic }, topic.uri);
                                        });
                                        break;
                                    case 'Contextual Keywords':
                                        optionValue = keywords.map((kw) => {
                                            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [kw, (0, jsx_runtime_1.jsx)("br", {})] }));
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            }
                            if (option.title === 'Included Locations') {
                                return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)("b", { children: "Included Locations" }) }), (0, jsx_runtime_1.jsx)("td", { children: geolocations === null || geolocations === void 0 ? void 0 : geolocations.map((loc) => {
                                                return (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(LocationView, { of: loc }) }, loc.uri);
                                            }) })] }, option.columnIndexInGoogleSheets));
                            }
                            if (option.title === 'Excluded Locations') {
                                return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)("b", { children: "Excluded Locations" }) }), (0, jsx_runtime_1.jsx)("td", { children: excludedGeolocations.map((loc) => (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(LocationView, { of: loc }) }, loc.uri)) })] }, option.columnIndexInGoogleSheets));
                            }
                            if (optionValue === undefined)
                                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
                            return ((0, jsx_runtime_1.jsxs)("tr", { style: { gap: '10px' }, children: [(0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)("b", { children: option.title }) }), (0, jsx_runtime_1.jsx)("td", { children: optionValue })] }, option.columnIndexInGoogleSheets));
                        })] }) }), !readonly && ((0, jsx_runtime_1.jsx)("input", { type: "button", onClick: async () => {
                    // if (campaign.adSets.size === 1)
                    // {
                    //   await campaign.delete();
                    // }
                    await template.delete();
                    deletionCallback ? deletionCallback() : window.location.reload();
                }, style: { backgroundColor: 'tomato' }, value: "Delete" }))] });
});
const TopicView = (0, package_1.linkedComponent)(Topic_1.Topic.request(t => ({
    name: t.name
})), ({ linkedData: { name } }) => {
    return (0, jsx_runtime_1.jsx)("div", { children: name });
});
const LocationView = (0, package_1.linkedComponent)(Location_1.Location.request(t => ({
    name: t.name
})), ({ linkedData: { name } }) => {
    return (0, jsx_runtime_1.jsx)("div", { children: name });
});
//# sourceMappingURL=TemplateDropdown.js.map